<button class="timepicker-button" type="button">
  <span><ng-content></ng-content></span>
</button>
